import appConfig from '../../configs/appConfig.js';
import envVariables from '../../consts/envVariables';
import iapMethods from '../../consts/iap/iapMethods';
import iapClient from './iapClient';
import iapMappingService from './iapMappingService';

const getCredentialsForLogging = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.CREDENTIALS_FOR_LOGGING,
        isThrowError: true,
        isAuthorized: true,
    });

const postAnonymousCredentialsForLogging = () =>
    iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.ANONYMOUS_GENERATE_TOKEN,
        isThrowError: true,
        isAuthorized: false,
    });

const postAnonymousPushLogs = (body, token) =>
    iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.ANONYMOUS_PUSH_LOGS,
        body,
        token,
        isThrowError: true,
        isAuthorized: true,
    });

const postRatingsImpression = (body) =>
    iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.RATINGS_IMPRESSION,
        body,
        isThrowError: true,
        isAuthorized: true,
    });

const postRatingsSubmit = (body) =>
    iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.RATINGS_SUBMIT,
        body,
        isThrowError: true,
        isAuthorized: true,
    });

const getIapLocalization = ({localizationFileName}) => {
    return iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.LOCALIZATION,
        pathParams: [localizationFileName],
        isThrowError: true,
        isLogResponse: false,
    });
};

const getIapCountryCode = () => {
    return iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.COUNTRY_CODE,
        isThrowError: true,
    });
};

const getIapConsents = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_CONSENTS_CLOUDFRONT_URL,
        path: iapMethods.CONSENTS,
        pathParams: [appConfig.getMarket()],
        mapping: iapMappingService.consentsMapping,
        isThrowError: true,
        isAuthorized: true,
        isLogResponse: false,
        isOfflineResponse: true,
    });

const getIapGeneralConfig = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.GENERAL_CONFIG,
        mapping: iapMappingService.generalConfigDataMapping,
        isThrowError: true,
    });

const getIapMarketConfig = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.MARKET_CONFIG,
        pathParams: [appConfig.getMarket()],
        mapping: iapMappingService.marketConfigDataMapping,
        isThrowError: true,
        isAuthorized: true,
    });

const getIapUserGroupsConfig = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.USER_GROUPS_CONFIG,
        mapping: iapMappingService.userGroupsConfigMapping,
        isThrowError: true,
        isAuthorized: true,
    });

const getIapTargetGroupsConfig = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL,
        path: iapMethods.TARGET_GROUPS_CONFIG,
        mapping: iapMappingService.targetGroupsConfigMapping,
        isThrowError: true,
        isAuthorized: true,
    });

const getCurrentSession = () =>
    iapClient.callGet({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.GET_CURRENT_SESSION,
        isThrowError: true,
        isAuthorized: true,
        isOnlineRequest: true,
    });

const postCreateSession = async (refreshToken) => {
    const body = {
        refreshToken,
    };

    return await iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.CREATE_SESSION,
        body,
        isThrowError: true,
        isAuthorized: true,
    });
};

const postUserLogout = async (refreshToken, token) => {
    const body = {
        refreshToken,
    };

    return await iapClient.callPost({
        endpoint: envVariables.IAP_BACKEND_API,
        path: iapMethods.LOGOUT_SESSION,
        body,
        token,
        isThrowError: false,
        isAuthorized: true,
    });
};

export default {
    postCreateSession,
    getCurrentSession,
    getCredentialsForLogging,
    postAnonymousCredentialsForLogging,
    postAnonymousPushLogs,
    postRatingsImpression,
    postRatingsSubmit,
    getIapLocalization,
    getIapConsents,
    getIapGeneralConfig,
    getIapMarketConfig,
    getIapUserGroupsConfig,
    getIapTargetGroupsConfig,
    postUserLogout,
    getIapCountryCode,
};
